<template>
  <v-card-subtitle class="px-0">
    <team-chip
      v-if="team"
      :team="team"
      close
      v-on:close="$router.push({ path: getCloseLink() })"
      class="mr-2 mb-2"
    ></team-chip>
    <user-chip
      v-if="manager"
      :user="manager"
      is-manager
      :close="manager.id != profile.id || is_admin"
      v-on:close="$router.push({ path: getCloseLink() })"
      class="mr-2 mb-2"
    ></user-chip>
    <user-chip
      v-if="user"
      :user="user"
      :close="user.id != profile.id || is_admin || profile.isManager"
      v-on:close="$router.push({ path: getCloseLink() })"
      class="mr-2 mb-2"
    ></user-chip>
    <v-chip
      v-if="category"
      color="background"
      text-color="secondarytext"
      close
      @click:close="$router.push({ path: getCloseLink(true) })"
      class="mr-2 mb-2"
    >
      {{ category.name }}
    </v-chip>
    <v-chip
      v-if="question"
      color="background"
      text-color="secondarytext"
      close
      @click:close="$router.push({ path: getCloseLink(true) })"
      class="mr-2 mb-2"
    >
      <v-icon
        class="mr-2"
        v-text="getQuestionTypeIcon(question.questionTypeId)"
      ></v-icon>
      {{ question.question }}
    </v-chip>
  </v-card-subtitle>
</template>

<script>
import questionTypes from "@/helpers/mixins/questionTypes";
import { mapGetters } from "vuex";
import reports from "@/helpers/mixins/reports";
export default {
  name: "ReportSubTitle",
  props: {
    filter: { type: Object },
    team: { type: Object },
    manager: { type: Object },
    user: { type: Object }
  },
  mixins: [reports, questionTypes],
  data: () => ({ questionTypes: questionTypes }),
  computed: {
    category() {
      return this.categories.find(x => x.id == this.filter.categoryId);
    },
    question() {
      return this.questions.find(x => x.id == this.filter.questionId);
    },
    ...mapGetters({
      categories: "settings/review_categories",
      questions: "settings/review_questions",
      profile: "profile/profile",
      is_admin: "profile/is_admin"
    })
  },
  methods: {}
};
</script>
